export const APPOINTMENTS = {
  FETCH_APPOINTMENTS: 'FETCH_APPOINTMENTS',
  FETCH_MONTH_APPOINTENTS: 'FETCH_MONTH_APPOINTENTS',
  FETCH_DISPOSITIONS: 'FETCH_DISPOSITIONS',
  SELECT_REASON: 'Select Reason',
  ACTIVE_DATE_CHANGED: 'ACTIVE_DATE_CHANGED',
  MAX_APPOINTMENT_DURATION: 3, // Hours
  TOGGLE_VIEW: 'TOGGLE_VIEW',
  UPDATE_CALENDAR: 'UPDATE_CALENDAR',
  UPDATE_BADGE_COUNT: 'UPDATE_BADGE_COUNT_APPOINTMENTS',
  STORE_ALL_APPOINTMENTS: 'STORE_ALL_APPOINTMENTS',
  MONTHS_LIMIT: 24,
  CONFIRMING_APPOINTMENT: 'Confirming Appointment',
  CONFIRMATION_TEXT: 'Please click YES to confirm your appointment.'
};

export const APPOINTMENT_STATUS = {
  TENTATIVE: { id: 1, name: 'Tentative', rank: 1, isActive: true, background: 'yellow', isReadOnly: false },
  AGENT_NOTIFIED: { id: 2, name: 'Agent Notified', rank: 2, isActive: false, background: 'yellow', isReadOnly: false },
  ACCEPTED: { id: 3, name: 'Accepted', rank: 3, isActive: true, background: 'yellow', isReadOnly: false },
  CONFIRMED: { id: 4, name: 'Confirmed', rank: 5, isActive: true, background: 'yellow', isReadOnly: false },
  COMPLETED: { id: 5, name: 'Completed', rank: 6, isActive: true, background: 'green', isReadOnly: false },
  CANCELLED: { id: 6, name: 'Cancelled', rank: 7, isActive: true, background: 'gray', isReadOnly: false },
  RESCHEDULED: { id: 7, name: 'Rescheduled', rank: 8, isActive: true, background: 'yellow', isReadOnly: false },
  MADE_CONTACT: { id: 8, name: 'Made Contact', rank: 4, isActive: true, background: 'yellow', isReadOnly: true },
  LEFT_MESSAGE: { id: 9, name: 'Left Message', rank: 9, isActive: true, background: 'yellow', isReadOnly: true },
  COULDNT_REACH: { id: 10, name: 'Couldn\'t Reach', rank: 10, isActive: true, background: 'yellow', isReadOnly: true }
};

export const APPOINTMENT_DISPOSITIONS = {
  AGENT_ACCEPTED_LEAD_AND_APPOINTMENT: 13,
  CONFIRMED_BY_AGENT_AND_CUSTOMER: 14,
  AGENT_MADE_CONTACT: 16,
  RESCHEDULED_BY_AGENT: 9
};

export const DISPOSITION_NAME = {
  NA: 'N/A'
};
